// @ts-nocheck
import { populate } from 'populate';
import type { Container, TilingSprite, Text, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '88a80bb7-bdce-4c5a-8792-d282d582d567',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: 'shopPopupTopBar',
      className: 'fullWidth',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'fd2176d6-8171-4688-86fc-8ce267ca1310',
      type: 'Container',
      name: 'coinContainerSlot',
      className: '',
      x: 14,
      y: 21,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'cd73284f-368a-4ff3-86f3-b6a38b858fd2',
      type: 'Text',
      name: 'storeLabel',
      className: '',
      x: 340,
      y: 60,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'STORE',
      localize: true,
      maxWidth: 220,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 52,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#300002',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          x: {
            value: 'WIDTH * 0.5'
          }
        }
      }
    },
    {
      id: '8b0cb571-ae8b-4555-9cad-c95f85e75153',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 718,
      y: 60,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -87,
        y: -62,
        width: 172,
        height: 129
      },
      texture: 'Shop_Close_Button_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        tapSound: 'UI_Button_Click',
        dynamicValues: {
          x: {
            value: 'WIDTH * 0.9'
          }
        }
      }
    },
    {
      id: 'a84e7362-bdd2-4ac2-8392-7b68302efa69',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: '8b0cb571-ae8b-4555-9cad-c95f85e75153'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class ShopPopupTopBarLayout {
  static raw = raw;
  root!: Container;
  shopPopupTopBar!: TilingSprite;
  coinContainerSlot!: Container;
  storeLabel!: Text & { data: typeof raw['list'][3]['data'] };
  closeButton!: Sprite & { data: typeof raw['list'][4]['data'] };
  fullWidth!: (TilingSprite)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
